import { render, staticRenderFns } from "./formulaUrgencia.vue?vue&type=template&id=24bdae04"
import script from "./formulaUrgencia.vue?vue&type=script&lang=js"
export * from "./formulaUrgencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports